module.exports = __webpack_public_path__ + "static/img/thumb-65.d9b4af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-65.png
// module id = 81
// module chunks = 0